<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" :width="params.width" :height="params.height" viewBox="0 0 47 47">
    <g v-if="params.groupIcon && !params.noIcon">
      <g :stroke="params.strokeColor">
        <circle cx="23.5" cy="23.5" r="22"
          :fill="params.backgroundWithOpacity ? params.backgroundWithOpacity.fillColor : 'none'"
          :fill-opacity="params.backgroundWithOpacity ? params.backgroundWithOpacity.opacity : '0'"
          stroke-width="2"/>
      </g>
      <g :fill="params.strokeColor" stroke="black">
        <text :stroke="params.textColor" font-weight="normal" :fill="params.textColor" x="50%" y="50%" text-anchor="middle" font-size="1.2em" font-family="Nunito Sans, sans-serif" dy=".3em">{{params.text}}</text>
      </g>
    </g>

    <g v-if="!params.groupIcon && !params.noIcon">
      <g v-if="params.iconClassName === 'player-green-check-icon'" :fill="params.fillColor" :stroke="params.strokeColor">
        <circle cx="23.5" cy="23.5" r="22"
          :fill="params.backgroundWithOpacity ? params.backgroundWithOpacity.fillColor : 'none'"
          :fill-opacity="params.backgroundWithOpacity ? params.backgroundWithOpacity.opacity : '0'"
          stroke-width="2"/>
        <g display="inline">
          <path d="M19.5,32.916c-0.137,0-0.268-0.055-0.361-0.154l-6.627-6.957
            c-0.191-0.2-0.184-0.517,0.017-0.707c0.199-0.19,0.517-0.184,0.706,0.018l6.238,6.547l14.266-17.396
            c0.176-0.213,0.49-0.244,0.703-0.07c0.215,0.176,0.245,0.49,0.07,0.704L19.887,32.733c-0.091,0.11-0.225,0.177-0.368,0.183
            C19.512,32.916,19.506,32.916,19.5,32.916L19.5,32.916z"/>
        </g>
      </g>

      <g v-if="params.iconClassName === 'player-orange-check-icon'" :fill="params.fillColor" :stroke="params.strokeColor">
        <circle cx="23.5" cy="23.5" r="22"
          :fill="params.backgroundWithOpacity ? params.backgroundWithOpacity.fillColor : 'none'"
          :fill-opacity="params.backgroundWithOpacity ? params.backgroundWithOpacity.opacity : '0'"
          stroke-width="2"/>
        <g display="inline">
          <path d="M19.5,32.916c-0.137,0-0.268-0.055-0.361-0.154l-6.627-6.957
            c-0.191-0.2-0.184-0.517,0.017-0.707c0.199-0.19,0.517-0.184,0.706,0.018l6.238,6.547l14.266-17.396
            c0.176-0.213,0.49-0.244,0.703-0.07c0.215,0.176,0.245,0.49,0.07,0.704L19.887,32.733c-0.091,0.11-0.225,0.177-0.368,0.183
            C19.512,32.916,19.506,32.916,19.5,32.916L19.5,32.916z"/>
        </g>
      </g>

      <g v-if="params.iconClassName === 'player-warning-icon'" :fill="params.fillColor" :stroke="params.strokeColor">
        <circle cx="23.5" cy="23.5" r="22"
          :fill="params.backgroundWithOpacity ? params.backgroundWithOpacity.fillColor : 'none'"
          :fill-opacity="params.backgroundWithOpacity ? params.backgroundWithOpacity.opacity : '0'"
          stroke-width="2"/>
        <path display="inline" d="M22.088,33.01c0-0.193,0.035-0.375,0.107-0.549
          c0.07-0.174,0.17-0.322,0.297-0.451c0.127-0.127,0.275-0.229,0.443-0.305s0.354-0.115,0.557-0.115
          c0.193,0,0.377,0.039,0.551,0.115c0.172,0.076,0.322,0.178,0.449,0.305c0.127,0.129,0.229,0.277,0.307,0.451
          c0.076,0.174,0.113,0.355,0.113,0.549c0,0.205-0.037,0.391-0.113,0.559c-0.078,0.168-0.18,0.314-0.307,0.441
          c-0.127,0.129-0.277,0.227-0.449,0.299c-0.174,0.07-0.357,0.107-0.551,0.107c-0.396,0-0.73-0.137-1-0.406
          S22.088,33.408,22.088,33.01z M24.256,12.584v8.732c0,0.457-0.006,0.891-0.016,1.297c-0.01,0.408-0.021,0.822-0.037,1.244
          c-0.016,0.424-0.039,0.869-0.068,1.336c-0.031,0.469-0.062,0.988-0.092,1.559h-0.992c-0.031-0.57-0.062-1.09-0.092-1.559
          c-0.031-0.467-0.055-0.912-0.07-1.336c-0.014-0.422-0.027-0.836-0.037-1.244c-0.01-0.406-0.016-0.84-0.016-1.297v-8.732H24.256z"/>
      </g>

      <g v-if="params.iconClassName === 'player-updating-icon'" :fill="params.fillColor" :stroke="params.strokeColor" opacity="0.9">
        <circle cx="23.5" cy="23.5" r="22"
          :fill="params.backgroundWithOpacity ? params.backgroundWithOpacity.fillColor : 'none'"
          :fill-opacity="params.backgroundWithOpacity ? params.backgroundWithOpacity.opacity : '0'"
          stroke-width="2"/>
        <g display="inline">
          <animateTransform attributeName="transform" type="rotate" begin="0s" from="360 23.5 25" to="0 23.5 25" dur="10s" repeatCount="indefinite" />
            <g>
              <path :fill="params.fillColor" :stroke="params.strokeColor" d="M23.5,35.106c-5.604,0-10.162-4.558-10.162-10.161c0-0.276,0.224-0.5,0.5-0.5
                s0.5,0.224,0.5,0.5c0,5.051,4.11,9.161,9.162,9.161c5.051,0,9.16-4.11,9.16-9.161c0-5.053-4.109-9.163-9.16-9.163
                c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5c5.603,0,10.16,4.56,10.16,10.163S29.103,35.106,23.5,35.106L23.5,35.106z"/>
            </g>
            <g>
              <path :fill="params.fillColor" :stroke="params.strokeColor" d="M25.195,18.967c-0.137,0-0.273-0.057-0.372-0.166l-2.725-3.037
                c-0.17-0.189-0.17-0.479,0-0.668l2.725-3.037c0.185-0.205,0.501-0.223,0.706-0.038s0.223,0.501,0.038,0.706l-2.425,2.703
                l2.425,2.703c0.185,0.205,0.167,0.521-0.038,0.706C25.434,18.925,25.314,18.967,25.195,18.967L25.195,18.967z"/>
            </g>
          </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: ['params']
}
</script>
